/*
 * The pages one tap away from the product page, fetched once the line is quiet.
 *
 * 2026-10-01: a `webpackPrefetch` hint put <link rel=prefetch> for the shop, the
 * checkout and the order-placed chunks in the head, and on a 4G line they shared
 * the bandwidth with the main script and the Hebrew strings — the buy button
 * paid a second for pages nobody was on. They are asked for after `load`, once
 * every picture the page asked for has arrived and nothing new has been asked
 * for in a while (utils/afterPageLoad), which is also when the pixel goes.
 */
import { afterPageLoad } from "./afterPageLoad";

const loaders = [
  () => import("../Pages/Shop"),
  () => import("../Pages/Checkout"),
  () => import("../Pages/Checkout/OrderPlaced"),
];
let asked = false;

export function prefetchShopperPages() {
  if (asked) return;
  asked = true;
  afterPageLoad(() => { loaders.forEach((load) => { try { load().catch(() => {}); } catch (_) { /* a chunk that cannot be asked for now is asked for on the tap */ } }); });
}

/*
 * AND THE CHECKOUT, THE MOMENT IT IS NEXT (2026-11-03). The owner, on an old Android phone in Instagram's browser: "and
 * the opening of the checkout as well". The quiet above can be ten seconds away on a slow phone (`load`, every photo,
 * 1.5 s of nothing new), and a shopper who added within it fetched and ran the checkout's chunk on the tap that opens
 * it. An add, or the cart opened, is the one moment the checkout is known to be the next page, so its chunk is asked
 * for then — once; webpack keeps the one fetch however many doors ask, and the after-load prefetch finds it done.
 * Installed once by App; returns the uninstall.
 */
const CART_DOORS = ["stylon:open-cart", "stylon:add-to-cart"];
const loadCheckout = () => import("../Pages/Checkout");

export function installCheckoutPrefetch({ win = typeof window !== "undefined" ? window : undefined, load = loadCheckout } = {}) {
  if (!win || typeof win.addEventListener !== "function") return () => {};
  let done = false;
  const ask = () => {
    if (done) return;
    done = true;
    CART_DOORS.forEach((type) => win.removeEventListener(type, ask));
    try { const p = load(); if (p && typeof p.catch === "function") p.catch(() => {}); } catch (_) { /* asked for again on the tap */ }
  };
  CART_DOORS.forEach((type) => win.addEventListener(type, ask));
  return () => CART_DOORS.forEach((type) => win.removeEventListener(type, ask));
}
